export const VIDEO_URL_LENGTH = 11;
export const VIDEO_ALIGNMENT = {
  start: 'start',
  center: 'center',
  end: 'end',
};
export const VIDEO_MIN_WIDTH = 250;
